/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {AgentWalletRetrievePaymentRequest} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_wallet_retrieve_payment_messages.pb'
import {AgentWalletRetrievePaymentResponse} from '@cash-web/protos/squareup/cash/agentcore/api/v1beta1/agent_wallet_retrieve_payment_messages.pb'


export const agentWalletRetrievePayment = (request: AgentWalletRetrievePaymentRequest, options?: CashRequestOptions) => post<AgentWalletRetrievePaymentRequest, AgentWalletRetrievePaymentResponse>("/2.0/cash/agent-wallet-retrieve-payment", request, {...options, rejectOnError: true })